<div class="invitation-page">
  <!-- Loading -->
  <div *ngIf="step === InvitationStep.Loading" class="state-container">
    <div class="spinner"></div>

    <p>
      {{ "invitation.loading" | translate }}
    </p>
  </div>

  <!-- Error -->
  <div *ngIf="step === InvitationStep.Error" class="state-container">
    <div class="state-icon error">
      <lucide-icon name="circle-alert" [size]="40"></lucide-icon>
    </div>

    <h1>
      {{ (invitationExpired | invitationErrorTranslationPrefix: alreadyMember) + ".title" | translate }}
    </h1>

    <p>
      {{ (invitationExpired | invitationErrorTranslationPrefix: alreadyMember) + ".description" | translate }}
    </p>
  </div>

  <!-- Main invitation -->
  <ng-container *ngIf="invitation && step !== InvitationStep.Loading">
    <!-- Header -->
    <header *ngIf="step !== InvitationStep.Error && step !== InvitationStep.Accepting" class="invitation-header">
      <div class="logo">
        <lucide-icon name="building-2" [size]="28"></lucide-icon>
      </div>

      <div>
        <p class="eyebrow">
          {{ "invitation.invitation" | translate }}
        </p>

        <h1>
          {{ "invitation.title" | translate }}
        </h1>

        <p class="subtitle">
          {{ invitation.data.orgName }}
        </p>
      </div>
    </header>

    <!-- ========================================================= -->
    <!-- EMAIL ALREADY KNOWN : NEW EMAIL -->
    <!-- ========================================================= -->

    <section *ngIf="step === InvitationStep.KnownEmail" class="invitation-card">
      <div class="card-header">
        <div class="card-icon">
          <lucide-icon name="mail-plus" [size]="28"></lucide-icon>
        </div>

        <div class="card-header-content">
          <h2>
            {{ "invitation.knownAccount.title" | translate }}
          </h2>

          <p>
            {{
              "invitation.knownAccount.description"
                | translate
                  : {
                      email: invitation.data.email,
                      organization: invitation.data.orgName
                    }
            }}
          </p>
        </div>
      </div>

      <app-invitation-email-form (emailSubmit)="knownEmailSubmit($event)"></app-invitation-email-form>
    </section>

    <!-- ========================================================= -->
    <!-- CHOICE: LOGIN OR REGISTER -->
    <!-- ========================================================= -->
    <section
      *ngIf="step === InvitationStep.Choice || step === InvitationStep.Login || step === InvitationStep.Register"
      class="choice-section"
    >
      <div class="choice-header">
        <h2>
          {{ "invitation.choose.title" | translate }}
        </h2>

        <p>
          {{ "invitation.choose.description" | translate }}
        </p>
      </div>

      <div class="choice-grid">
        <button
          type="button"
          class="choice-card"
          [class.selected]="selectedChoice === InvitationChoice.Login"
          (click)="selectChoice(InvitationChoice.Login)"
        >
          <div class="choice-icon">
            <lucide-icon name="log-in" [size]="30"></lucide-icon>
          </div>

          <div class="choice-content">
            <h3>
              {{ "invitation.choose.login.title" | translate }}
            </h3>

            <p>
              {{ "invitation.choose.login.description" | translate }}
            </p>
          </div>
        </button>

        <button
          type="button"
          class="choice-card"
          [class.selected]="selectedChoice === InvitationChoice.Register"
          (click)="selectChoice(InvitationChoice.Register)"
        >
          <div class="choice-icon">
            <lucide-icon name="user-plus" [size]="30"></lucide-icon>
          </div>

          <div class="choice-content">
            <h3>
              {{ "invitation.choose.register.title" | translate }}
            </h3>

            <p>
              {{ "invitation.choose.register.description" | translate }}
            </p>
          </div>
        </button>
      </div>
    </section>

    <!-- ========================================================= -->
    <!-- LOGIN -->
    <!-- ========================================================= -->

    <section *ngIf="step === InvitationStep.Login" #activeChoiceSection class="invitation-card">
      <div class="card-header">
        <div class="card-icon">
          <lucide-icon name="log-in" [size]="28"></lucide-icon>
        </div>

        <div class="card-header-content">
          <h2>
            {{ "invitation.login.title" | translate }}
          </h2>

          <p>
            {{ "invitation.login.description" | translate }}
          </p>
        </div>
      </div>

      <app-login-form [persistSession]="false" (loginTokens)="loginTokensReceived($event)"></app-login-form>
    </section>

    <!-- ========================================================= -->
    <!-- REGISTER -->
    <!-- ========================================================= -->

    <section *ngIf="step === InvitationStep.Register" #activeChoiceSection class="invitation-card">
      <div class="card-header">
        <div class="card-icon">
          <lucide-icon name="user-plus" [size]="28"></lucide-icon>
        </div>

        <div class="card-header-content">
          <h2>
            {{ "invitation.register.title" | translate }}
          </h2>

          <p>
            {{ "invitation.register.description" | translate }}
          </p>
        </div>
      </div>

      <app-invitation-password-form (passwordSubmit)="registerSubmit($event)"></app-invitation-password-form>
    </section>

    <!-- ========================================================= -->
    <!-- ACCEPTING -->
    <!-- ========================================================= -->

    <section *ngIf="step === InvitationStep.Accepting" class="state-container">
      <div class="spinner"></div>

      <h2>
        {{ "invitation.accepting.title" | translate }}
      </h2>

      <p>
        {{ "invitation.accepting.description" | translate }}
      </p>
    </section>
  </ng-container>
</div>
